import { render, staticRenderFns } from "./ExperimentalPage.vue?vue&type=template&id=c11bcbe6&scoped=true"
import script from "./ExperimentalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperimentalPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11bcbe6",
  null
  
)

export default component.exports